import { Link } from "react-router-dom";
import { LogIn, UserPlus, Gift } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useLang } from "@/lib/i18n";

const HERO =
  "https://images.unsplash.com/photo-1709548145082-04d0cde481d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxjb3p5JTIwZWxlZ2FudCUyMGRhcmslMjByZXN0YXVyYW50JTIwaW50ZXJpb3J8ZW58MHx8fHwxNzkwNzkzMzc0fDA&ixlib=rb-4.1.0&q=85";

const btn =
  "group flex h-16 w-full items-center justify-center gap-3 rounded-full text-base font-700 uppercase tracking-wide transition-[background-color,transform,border-color] duration-200 hover:-translate-y-0.5";

export default function Start() {
  const { t } = useLang();
  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-[#1A1715]">
      <div className="absolute inset-0">
        <img src={HERO} alt="" className="animate-bg-drift h-full w-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A1715]/45 via-[#1A1715]/60 to-[#1A1715]/95" />
      </div>
      <div className="relative z-10 mx-auto flex min-h-screen max-w-xl flex-col px-5 py-8 sm:py-12">
        <header className="flex items-center justify-center animate-fade-in">
          <Logo />
        </header>
        <main className="flex flex-1 flex-col justify-center py-10 text-center">
          <div className="animate-fade-up">
            <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/10">
              <Gift className="h-6 w-6 text-[#D4AF37]" />
            </div>
            <h1 className="font-serif-display text-4xl font-600 leading-tight text-[#FDFBF7] sm:text-5xl">{t("Velkommen til Demo", "Welcome to Demo")}</h1>
            <p className="mx-auto mt-4 max-w-md text-base text-[#FDFBF7]/90">
              {t("Registrer deg for å få en gave fra oss, eller logg inn for å se og bruke kupongene dine.", "Sign up to get a gift from us, or log in to see and use your coupons.")}
            </p>
          </div>
          <div className="mx-auto mt-10 flex w-full max-w-sm flex-col gap-4 animate-fade-up" style={{ animationDelay: "0.15s" }}>
            <Link to="/gave/registrer" className={`${btn} bg-[#D4AF37] text-[#1A1715] hover:bg-[#E5C564]`} data-testid="start-register-btn">
              <UserPlus className="h-5 w-5" /> {t("Registrer deg", "Sign up")}
            </Link>
            <Link to="/logg-inn" className={`${btn} border border-[#D4AF37]/50 bg-[#1A1715]/70 text-[#E5C564] backdrop-blur-md hover:border-[#D4AF37] hover:bg-[#D4AF37]/10`} data-testid="start-login-btn">
              <LogIn className="h-5 w-5" /> {t("Logg inn", "Log in")}
            </Link>
            <p className="mt-2 text-xs text-[#A8A29E]">{t("Allerede registrert? Logg inn med telefonnummeret ditt, så får du en kode på SMS.", "Already registered? Log in with your phone number and we'll text you a code.")}</p>
          </div>
        </main>
        <footer className="text-center text-xs text-[#A8A29E]/60">
          <Link to="/admin" className="hover:text-[#D4AF37]" data-testid="link-admin">Admin</Link>
        </footer>
      </div>
    </div>
  );
}
